module.exports = __webpack_public_path__ + "static/img/icon-lab-02.7756415f.png";